<template>
    <div class="users-style">
        <!-- Abdullah added this code here  -->
          <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance<span>

             <!-- AbdullahALC chnaged pageurl to api url -->
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance / Leave Policy</span>
        </h4>

        <div class="row no-margin mt-4">  <!-- Abdullah added this code here  -->
            <div class="ibox col-md-12 px-4">  <!-- Abdullah added this code here  -->
                    <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
                <div class="ibox-title dashboard_title px-0">  <!-- Abdullah added this code here  -->
                    <h4>Leave Policy</h4>
                </div>
                <div class="ibox-content px-0 pt-4 employee-table-wrapper">  <!-- Abdullah added this code here  -->
                    <div class="row no-gutters py-2 mb-3 pl-0 ">  <!-- Abdullah added this code here  -->
                        <div class="col-sm-6">
                            <div class="custom-search">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.. " v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title">  <!-- Abdullah added this code here  -->
                            <b-button id="show-btn" v-if="ce" @click="addNewLeavePolicy()">Add Leave Policy</b-button>
                        </div>
                    </div>

                    <b-overlay :show="showoverlay" rounded="sm">
                        <table class="table dataTable no-sort-icon leave-table"> <!-- Abdullah added this code here  -->
                            <thead>
                                <!-- Abdullah26 added :style="{ fontSize: '16px' }"  -->
                                <tr class="table-head">  <!-- Abdullah added this code here  -->
                                    <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span :style="{ fontSize: '16px' }">{{column.label}}</span></th>
                                    <!-- Abdullah26 added text center  -->
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="leavepolicy in paginatedData" :key="leavepolicy.id">  <!-- Abdullah added this code here  -->
                                    <td>{{leavepolicy.title}}</td>
                                    <td>

                                        <div class="float-right position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group >
                                                        <b-button variant="outline-secondary"  v-if="ce" @click="leaveTypes(leavepolicy.id)">
                                                            <b-icon icon="list-ul"></b-icon> Leave Types
                                                        </b-button>
                                                        <b-button variant="outline-secondary"  v-if="ce" @click="editLeavePolicy(leavepolicy.id)">
                                                            <b-icon icon="pencil"></b-icon> Edit
                                                        </b-button>
                                                        <b-button variant="outline-secondary"  v-if="ce" @click="deleteLeavePolicy(leavepolicy.id)">
                                                            <b-icon icon="trash"></b-icon> Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>

                                <!-- Abdullah commented this code  -->
                                <!-- <tr v-if="paginatedData.length > 0"><td :colspan="6">
                                    <div class="row p-2 float-right" >
                                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                                    </div></td></tr>
                                <tr v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr> -->
                            </tbody>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                        <div v-else class="row py-2 no-margin">
                            <div class="col-md-12 p-0 no-margin">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{pagination.total}} records found.</li>
                                </ul>
                                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                            </div>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>


        <b-modal id="bv-modal-leave_policies" size="lg" hide-footer :title="leave_type_details" modal-class="w-600">  <!-- Abdullah added title and modal-class here  -->


                <!--<ul class="list-group mb-3 " v-if='errormsg'>
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                </ul>-->

                <b-overlay :show="showoverlaymodal" rounded="sm">
                    <b-form @submit.stop.prevent="onSubmit">
                        <input type="hidden" v-model="fdata.id" name="id">
                        <div class=" row">
                            <div class="col-sm-12">
                                <b-form-group id="title-group" label="Title" label-for="title">
                                    <b-form-input id="title" name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Title"></b-form-input>
                                    <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
                                </b-form-group>


                            </div>

                            <!-- AbdullahFixed added this code here  -->
                            <div class="col-sm-12">

                                <b-form-checkbox v-model="fdata.long_service_status" name="check-button" class="pt-2" :value="1" :unchecked-value="0" switch v-if="long_service_status == 1">
                                    Enable Long Service Leave
                                </b-form-checkbox>
                            </div>
                        </div>

                        <!-- Abdullah commented this  -->
                        <!-- <b-button type="submit" variant="success">Submit</b-button>
                        <b-button class="ml-2" variant="success" @click="resetForm()">Reset</b-button> -->

                        <!-- Abdullah added this  -->
                         <div class="btn-wrapper text-center pt-5">
                            <!-- alpha fix- swap the btns  -->
                            <b-button class="btn-primary" type="submit" variant="primary">Submit</b-button>
                            <b-button class="ml-2 btn-primary custom-wizard-btn" variant="primary" @click="resetForm()">Reset</b-button>

                        </div>
                    </b-form>
                </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-leave_types" size="lg" hide-footer :title="'Leave Types for ' + selected_policy_title">
            <!--<b-alert show>Zero/empty days indicates leave type is not allowed for this leave policy.</b-alert>-->
            <table class="table dataTable">
                <thead>
                    <tr class="table-head">

                        <!-- Abdullah commented this  -->
                        <!-- <th class="text-left">Leave Type</th>
                        <th class="text-left">Allowed Days</th> -->

                        <!-- Abdullah added this -->
                        <th class="checkbox-col">

                        </th>
                        <th class="">Leave Type</th>
                        <th class="">Allowed Days</th>
                    </tr>
                </thead>
                <tbody>

                    <!-- Abdullah commented this  -->
                    <!-- <template v-for="leavetype in leavetypes" >
                        <tr class="hover-bg table-row border-bottom mx-2" :class="{ 'd-none': leavetype.override_leave_policy == 1 }">
                            <td>

                                <b-form-checkbox v-model="cdata[leavetype.id]" name="check-button" class="pt-2" @change="fake()">
                                    {{leavetype.title}}
                                </b-form-checkbox>
                            </td>
                            <td :key="c+'b'" v-if="!leavetype.title.includes('Long Service')">
                                <b-form-input v-if="cdata[leavetype.id]" id="title" name="title" v-model="ldata[leavetype.id]" :key="c+'c'"></b-form-input>
                                <b-form-input v-else id="title" name="title" v-model="ldata[leavetype.id]" :key="c+'c'" disabled></b-form-input>
                            </td>

                        </tr>
                    </template> -->

                    <!-- Abdullah added this  -->

                    <tr class="hover-bg table-row border-bottom mx-2" v-for="leavetype in leavetypes" :key="leavetype.id">
                        <td class="text-center">
                            <b-form-checkbox v-model="cdata[leavetype.id]" name="check-button" class="mt-0" @change="fake()">

                            </b-form-checkbox>
                        </td>
                        <td>{{leavetype.title}}</td>
                        <td :key="c+'b'">
                            <b-form-input v-if="cdata[leavetype.id]" id="title" name="title" v-model="ldata[leavetype.id]" :key="c+'c'"></b-form-input>
                            <b-form-input v-else id="title" name="title" v-model="ldata[leavetype.id]" :key="c+'c'" disabled></b-form-input>
                        </td>
                    </tr>

                    <!-- Abdullah commented this  -->
                    <!-- <tr class="hover-bg table-row border-bottom mx-2">
                        <td colspan="2"><b-button type="submit" variant="primary" class="mt-4" @click="leavePolicyTypeMapping()">Submit</b-button></td>
                    </tr> -->
                </tbody>

            </table>
            <!-- Abdullah added this  -->
              <div class="btn-wrapper text-center pt-5">
                <b-button type="submit" variant="primary" class="mt-4" @click="leavePolicyTypeMapping()">Submit</b-button>
            </div>

        </b-modal>

    </div>
</template>


<script>
    export default{

        mounted() {
            //console.log('Bank info started..');
            //console.log(this.employee_id);
            this.$acl['leave-attendances'] = 2;
        },
        props: [],
        data(){

            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'title' },
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {
                cu : window.location.href,
                ce : true,
                c : 0,
                long_service_status: 0,
                pagetitle: 'Leave Policy',
                search:'',
                leavepolicy_title : [],
                leavepolicies : [],
                leavetypes : [],

                selected_policy_id : 0,
                selected_policy_title : '',

                successmsg : '',
                errormsg : [],
                blankmsg : 'Fetching data..',
                fdata : {id:null, title: '', long_service_status: 0},
                ldata : {},
                cdata : {},

                showoverlay : false,
                showoverlaymodal : false,

                yes_no:[
                    { value: "0", text: "No" },
                    { value: "1", text: "Yes" },
                ],

                length: 10,
                pagination: {currentPage: 1, total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                columns: columns,
                sortKey: 'title',
                sortOrders: sortOrders,

                // AbdullahALC chnaged length options
                length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
                temp_length:20,
                leave_type_details: 'Add Leave Policy',
                  // AbdullahALC chnaged length options upto this

            }
        },
        methods:{

            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },
            fake()
            {
                this.c = this.c + 1;
            },
            getPolicy() {
                axios.get(this.$api_url + '/longservice-leave/check').then((response) => {
                        this.long_service_status = response.data;
                        this.getTypeList();
                    }).catch((err) => {
                        console.error('Error fetching policies:', err);
                    });
            },
            getTypeList: function()
            {
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/leave/types' , {
                    params: {

                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.leavetypes = response.data;

                        this.leavetypes = this.leavetypes.filter(item => !item.title.includes('Compensatory') && !item.title.includes('Long Service'));

                }.bind(this));
            },
            leaveTypes:function(x)
            {
                this.selected_policy_id = x;
                this.selected_policy_title = this.leavepolicy_title[x];
                this.leavePolicyTypeMappingData();
                this.$bvModal.show('bv-modal-leave_types');

            },
            leavePolicyTypeMappingData: function()
            {
                if(!this.checkNet()) return false;
                for (let [key, value] of Object.entries(this.ldata))
                {
                    this.ldata[key] = 0;
                    this.cdata[key] = false;
                    this.c = this.c + 1;
                }
                axios.get(this.$api_url+'/leave/policy/type/mapping/'+this.selected_policy_id , {
                    params: {

                    }
                }).then(function(response){
                    response.data.forEach(element => {
                        this.ldata[element.leave_type_id] = element.leave_days;
                        this.cdata[element.leave_type_id] = (element.leave_days > 0);
                        this.c = this.c + 1;
                    });
                }.bind(this));
            },
            leavePolicyTypeMapping:function(e)
            {
                if(!this.checkNet()) return false;

                let currentObj = this;
                let formData = new FormData();

                formData.append('leave_policy_id', this.selected_policy_id);

                for (let [key, value] of Object.entries(this.ldata))
                {
                    var nm = `${key}`;
                    var fval = `${value}`;

                    if(this.cdata[key] == false)
                        fval = 0;

                    formData.append(nm, fval);
                    console.log(`${key}: ${fval}`);
                }

                //return;

                axios.post(this.$api_url+'/leave/policy/type/mapping', formData)
                                .then(function (response)
                                {
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });

                this.$bvModal.hide('bv-modal-leave_types');
            },



            getPolicyList: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;

                let arr = [];
                axios.get(this.$api_url+'/leave/policies' , {
                    params: {

                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.leavepolicies = response.data;

                    response.data.forEach(element => {
                        arr[element.id] = element.title;

                    });

                    this.leavepolicy_title = arr;


                    this.pagination.total = response.data.length;

                    this.showoverlay = false;

                    if(this.leavepolicies.length == 0)
                        this.blankmsg = "Nothing found.";
                }.bind(this));
            },
            editLeavePolicy:function(x)
            {
                if(!this.checkNet()) return false;

                // AbdullahALC chnaged added leave type detais
                this.leave_type_details = 'Edit Leave Policy';
                let currentObj = this;
                this.errormsg = [];
                this.successmsg = '';
                axios.get(this.$api_url+'/leave/policy/details/'+x , {
                    params: {

                    }
                }).then(function(response){
                    console.log(this.fdata);
                    this.fdata = response.data;
                    this.$validator.reset();
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.serverError(error);
                });

                this.$bvModal.show('bv-modal-leave_policies');

            },
            deleteLeavePolicy:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this leave policy.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        //alert(x);
                        let currentObj = this;
                        //this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/leave/policy/delete', formData).then(function(response){

                            if(response.data.status == true)
                            {
                                //this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                this.getPolicyList();
                            }
                            else
                            {
                                //this.warningmsg = response.data.meg;
                                //alert(response.data.meg);
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        });
                            }


                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                        });
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            // AbdullahFixed this. added long_service_status: 0
            resetForm()
            {
                this.fdata = {id:null, title: '', long_service_status: 0};


            },
            addNewLeavePolicy()
            {
                this.resetForm();
                 // AbdullahALC chnaged ends
                this.leave_type_details = 'Add Leave Policy';
                // AbdullahALC chnaged ends
                this.$bvModal.show('bv-modal-leave_policies');
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlaymodal = true;
                    e.preventDefault();
                    let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/leave/policy/save', formData)
                                .then(function (response)
                                {
                                    this.leavepolicies = response.data;
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.$bvModal.hide('bv-modal-leave_policies');
                                    this.showoverlaymodal = false;
                                    this.resetForm();

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                    for (var data in currentObj.errormsg)
                                    {
                                        var msg = currentObj.errormsg[data];
                                        currentObj.$bvToast.toast(msg, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                        currentObj.$validator.reset();
                                    }
                                });
                });
            },

        },
        created: function(){
            //this.getAcl();
            this.getPolicy();
            this.getPolicyList();
            // this.getTypeList();
            Fire.$on('reloadUsers', () => {this.getPolicyList()})
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.leavepolicies;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
